import { authenticationClient, client }  from './Client';

export const submissionsApi = {
  authenticate: (credentials) => 
    authenticationClient.post('/authenticate', credentials),
  
  downloadFramework: (frameworkId) =>
    client.get(`/frameworks/${frameworkId}/download`),
  
  downloadUploadedFile: (fileId) => 
    client.get(`/indicator-submissions/files/${fileId}/download`),
  
  getAll: () => client.get('/submissions'),

  createSubmission: (data) => client.post('/submissions', data),

  getIndicators: (submissionId) => 
    client.get(`/submissions/${submissionId}/indicators`),

  getStandardsIndicators: (submissionId) => 
    client.get(`/submissions/${submissionId}/standards-with-indicators`),

  getAllFrameworks: ()=>
    client.get('/frameworks'),

  getIndicatorSubmission: (id) => 
    client.get(`/indicator-submissions/${id}`),

  updateIndicatorText: (id, text) => 
    client.put(`/indicator-submissions/${id}/text`, { text }),

  getAgentRecommendation: (id) => 
    client.get(`/agent-recommendations/${id}`),

  getAgentSubmissionRecommendation: (id) => 
    client.get(`/agent-submission-recommendations/${id}`),
 
  invokeAiCheck: (id) => 
    client.post(`/indicator-submissions/${id}/invoke-ai-check`),

  generateUploadUrl: (indicatorSubmissionId, submissionData) =>{ 
    return client.post(`/indicator-submissions/${indicatorSubmissionId}/files/upload-url`, submissionData)
  },
  markUploadComplete: (fileId) => 
    client.post(`/indicator-submissions/files/${fileId}/complete`),
    
  deleteUploadedFile: (fileId) => 
    client.delete(`/indicator-submissions/files/${fileId}`),
  
  getLatestAgentSubmissionRecommendations: (submissionId) =>
    client.get(`/agent-latest-submission-recommendations/${submissionId}`),

  sendOtp: async (credentials) => {
    try {
      const response = await authenticationClient.post('/send_otp', credentials);
      return response;
    } catch (error) {
      if (error.response?.status === 408) {
        throw new Error('Server is currently unavailable. Please try again later.');
      } else if (error.response?.status === 401) {
        throw new Error('Invalid credentials. Please check your email and password.');
      } else {
        throw new Error('An unexpected error occurred. Please try again.');
      }
    }
  },
    
  verifyOtpAndAuthenticate: async (authData) => {
    try {
      const response = await authenticationClient.post('/authenticate', authData);
      return response;
    } catch (error) {
      const status = error.response?.status;
      const detail = error.response?.data?.detail;
      if (status === 408) {
        throw new Error('Server is currently unavailable. Please try again later.');
      }
      if (status === 401) {
        if (detail === 'QMS Invalid OTP') {
          throw new Error('Invalid OTP code. Please try again.');
        }
        if (detail === 'Invalid OTP or credentials') {
          throw new Error('Invalid OTP or credentials. Please try again.');
        }
      }
      // Surface the real backend reason (e.g. "Invalid Password") instead of a misleading OTP prompt
      throw new Error(detail || 'An unexpected error occurred. Please try again.');
    }
  },

  submitSubmission: async (submissionId) => {
    try {
      const response = await client.post(`/submissions/${submissionId}/submit`);
      return response;
    } catch (error) {
      if (error.response?.data?.detail) {
        const { error_code, message } = error.response.data.detail;
        switch (error_code) {
          case 1:
            throw new Error('Some indicator submissions are missing file uploads. Please upload all required files before submitting.');
          case 2:
            throw new Error('Some indicator submissions are missing text input. Please provide all required text inputs before submitting.');
          case 3:
            throw new Error('Some indicator submissions have not been processed by AI. Please wait for AI processing to complete before submitting.');
          default:
            throw new Error(message || 'An error occurred while submitting the application.');
        }
      }
      throw new Error('An unexpected error occurred while submitting the application. Please try again.');
    }
  },

};